<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar nova compra"
             col-md="col-md-5" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.fornecedor"
                    inputId="fornecedor"
                    :options="fornecedores"
                    optionLabel="razao_social"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('fornecedor')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="fornecedor">
                  <strong>Fornecedor:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="vendedor" v-model="dado.vendedor" size="small" style="width: 100%"/>
                <label for="vendedor"><strong>Vendedor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_compra" v-model="dado.data_compra" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataCompra" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_compra')"/>
                <label for="data_compra"><strong>Data Compra: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_total" v-model="dado.valor_total" size="small" style="width: 100%"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"
                             :invalid="campoVazio.includes('valor_total')"/>
                <label for="valor_total"><strong>Valor Total: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarCompras",
  components: {
    BaseModal,
  },
  emits: ["fechar", "atualizarLista"],
  data() {
    return {
      fornecedores: [],
      dado: {
        fornecedor: "",
        vendedor: "",
        data_compra: null,
        valor_total: "",
        observacao: "",
        usuario: "user",
      },
      campoVazio: [],
    }
  },
  methods: {
    async getFornecedores() {
      const resultado = await apiRequest("GET", apiUrl.fornecedores.createList);
      if (resultado.success) {
        this.fornecedores = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_compra']);
      const resultado = await apiRequest("POST", apiUrl.compras.createList, this.dado);
      if (resultado.success) {
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getFornecedores();
    Inputmask("99/99/9999").mask(this.$refs.dataCompra.$el.querySelector("input"));
  }
}
</script>
